import React from 'react';
import s from './Phone.scss';

const Phone = ({ hot, apptype }) => {
    
    let phone, link;
    if(apptype === 'ce'){
        phone = '(11) 6842-0712';
        link = '1168420712';
    }else{
        if(hot){
            phone = '(11) 6842-0730';
            link = '116842-0730';
        }else{
            phone = '(11) 6842-0730'
            link = '116842-0730';
        }
    }
    return(
        <a className={s.phoneNumber} href={`tel:${link}`}>{phone}</a>
    );
}

export default Phone;
